import de from './de';
import en from './en';

export const translations = { de, en };
export const supportedLanguages = [
  { key: 'de', label: 'Deutsch', flag: 'DE' },
  { key: 'en', label: 'English', flag: 'EN' },
];
export const defaultLanguage = 'de';
